import { render } from "./DashboardV2.vue?vue&type=template&id=dac0b368"
import script from "./DashboardV2.vue?vue&type=script&lang=js"
export * from "./DashboardV2.vue?vue&type=script&lang=js"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__